import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var ImageStackIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 24 24",
                    children: [
                        _jsx("path", {
                            d: "M20.65 6.47H8.73c-1.17 0-2.12.95-2.12 2.12v12.29c0 1.17.95 2.12 2.12 2.12h11.92c1.17 0 2.12-.95 2.12-2.12V8.59c0-1.17-.95-2.12-2.12-2.12zm-11.92 2h11.92c.07 0 .12.05.12.12v7.7c-.5-.17-1.03-.29-1.53-.29h-.03c-1.1 0-2.06.2-3.17.63-.2-.2-.41-.39-.64-.57A9.205 9.205 0 009.41 14c-.28 0-.54 0-.8.03V8.59c0-.06.05-.12.12-.12zm-.12 12.41v-4.83c.27-.02.55-.04.82-.05 1.71-.06 3.38.53 4.71 1.61 1.09.88 1.87 2.07 2.3 3.39H8.73c-.06 0-.12-.05-.12-.12zm12.04.12h-2.11c-.24-.97-.64-1.89-1.17-2.72.62-.19 1.2-.28 1.84-.28h.02c.54 0 1.14.22 1.53.48v2.4c0 .07-.05.12-.12.12h.01z"
                        }),
                        _jsx("path", {
                            d: "M17.01 15.18c1.63 0 2.96-1.33 2.96-2.96s-1.33-2.96-2.96-2.96-2.96 1.33-2.96 2.96 1.33 2.96 2.96 2.96zm0-3.91a.96.96 0 110 1.92.96.96 0 010-1.92zM4.49 15.53H3.34c-.06 0-.12-.05-.12-.12V3.12c0-.06.05-.12.12-.12l12.38-.02s.03.06.03.14V4c0 .55.45 1 1 1s1-.45 1-1v-.88c0-1.21-.86-2.12-2-2.12H3.35c-1.17 0-2.12.95-2.12 2.12v12.29c0 1.17.95 2.12 2.12 2.12H4.5c.55 0 1-.45 1-1s-.45-1-1-1h-.01z"
                        })
                    ]
                })
            })
        ]
    });
};
ImageStackIcon.isCarinaIcon = true;
export default ImageStackIcon;
